<template>
  <div class="recipe-list">
    <div class="section-header">
      <InputField name="recipeSearch" :placeholder="$t('recipelist.search')" icon="magnifier"></InputField>
      <div class="result-info">
        <span>{{ recipes.length }} {{ $t('recipelist.product-amount') }}</span>
      </div>
    </div>
    <ul>
      <li>
        <a :href="catalogueUrl" target="_blank">
          <div class="preview">
            <image-loader src="/src/images/icons/productcatalog.svg"></image-loader>
          </div>
          <h4>{{ $t('recipelist.product-catalogue') }}</h4>
        </a>
      </li>
      <li v-for="recipe in recipes" :key="recipe.id" v-on:click="selectRecipe(recipe)">
        <article>
          <div class="preview">
            <image-loader :name="recipe.name" :src="recipe.image"></image-loader>
          </div>
          <h1>{{ recipe.name }}</h1>
        </article>
      </li>
    </ul>
  </div>
</template>

<script>
import loaderMixin from "@/mixins/loaderMixin";
import ImageLoader from "./ImageLoader";
import InputField from "./InputField";

export default {
  name: "RecipeList",
  components: {InputField, ImageLoader},
  mixins: [loaderMixin],
  computed: {
    recipes: function () {
      return this.$store.getters.recipes;
    },
    catalogueUrl: function () {
      return this.$store.getters.catalogueUrl
    }
  },
  methods: {
    /**
     * apply selected recipe
     * @param recipe
     */
    selectRecipe: function (recipe) {
      let bun = this.$store.getters.byId('buns', parseInt(recipe.bun));

      //commit recipe name
      this.$store.commit('setRecipeName', recipe.name);
      //commit recipe bun
      this.$store.commit('selectBun', bun);
      //commit recipe options
      this.loadRecipe(recipe);
    },
    /**
     * check if search is active
     */
    isTyping: function () {
      return (this.recipeSearch.length > 0);
    },

    clearField: function () {
      this.recipeSearch = '';
    }
  }
}
</script>